import React from 'react';
import { SolidButtonLink } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './PreviewHeader.styles';

export interface PreviewHeaderProps {
  href: string;
}

export const PreviewHeader = ({ href }: PreviewHeaderProps) => (
  <header css={styles.container}>
    <SolidButtonLink compact href={href}>
      Exit Preview
    </SolidButtonLink>
  </header>
);
